export default __webpack_public_path__ + "static/media/play-button.7671e3a2.svg";